<div class="w-p-100 flex flex-row justify-between items-center">
  <ul class="grid-mini-button-container m-l-10">
    <button *ngIf="item.cells[fieldDefinition.key]?.value && item.cells[fieldDefinition.key]?.value === 'Y'" mat-button
            class="grid-mini-button"
            matTooltip="Click here to view {{fieldDefinition.header}}" (click)="navigateToTreaty()">
      Yes
    </button>

    <button *ngIf="item.cells[fieldDefinition.key]?.value && item.cells[fieldDefinition.key]?.value === 'N'" mat-button
            disabled class="grid-mini-button">
      No
    </button>
  </ul>
</div>


